//import { myPage } from './Reducers/MyPage.reducer';

export const pnReducers = {
};

